import { z } from 'zod';
import {
    CloverPaymentRequestFollowUpOperation,
    type CloverPaymentRequestFollowUpRefundRequestDetails,
    type CloverPaymentRequestFollowUpRefundResponseDetails,
    type CloverPaymentRequestFollowUpRequestDetails,
    type CloverPaymentRequestFollowUpResponseDetails,
    type CloverPaymentRequestFollowUpResult,
    type CloverPaymentRequestFollowUpTransactionResult,
    type CloverPaymentRequestFollowUpVoidRequestDetails,
    type CloverPaymentRequestFollowUpVoidResponseDetails,
} from '../../../types/ipg/clover/clover-payment-request-follow-up.types';
import {
    CloverRefundRequestDetailsSchema,
    CloverRefundResponseDetailsSchema,
} from './clover-refund.schemas';
import {
    CloverVoidRequestDetailsSchema,
    CloverVoidResponseDetailsSchema,
} from './clover-void.schemas';

export const CloverPaymentRequestFollowUpVoidRequestDetailsSchema: z.ZodType<CloverPaymentRequestFollowUpVoidRequestDetails> =
    z.object({
        operation: z.literal(CloverPaymentRequestFollowUpOperation.VOID),
        transactions: z.array(CloverVoidRequestDetailsSchema).min(1),
    });

export const CloverPaymentRequestFollowUpRefundRequestDetailsSchema: z.ZodType<CloverPaymentRequestFollowUpRefundRequestDetails> =
    z.object({
        operation: z.literal(CloverPaymentRequestFollowUpOperation.REFUND),
        transactions: z.array(CloverRefundRequestDetailsSchema).min(1),
    });

export const CloverPaymentRequestFollowUpRequestDetailsSchema: z.ZodType<CloverPaymentRequestFollowUpRequestDetails> =
    z.union([
        CloverPaymentRequestFollowUpVoidRequestDetailsSchema,
        CloverPaymentRequestFollowUpRefundRequestDetailsSchema,
    ]);

export const CloverPaymentRequestFollowUpVoidResponseDetailsSchema: z.ZodType<CloverPaymentRequestFollowUpVoidResponseDetails> =
    z.object({
        operation: z.literal(CloverPaymentRequestFollowUpOperation.VOID),
        transactions: z.array(CloverVoidResponseDetailsSchema).min(1),
    });

export const CloverPaymentRequestFollowUpRefundResponseDetailsSchema: z.ZodType<CloverPaymentRequestFollowUpRefundResponseDetails> =
    z.object({
        operation: z.literal(CloverPaymentRequestFollowUpOperation.REFUND),
        transactions: z.array(CloverRefundResponseDetailsSchema).min(1),
    });

export const CloverPaymentRequestFollowUpResponseDetailsSchema: z.ZodType<CloverPaymentRequestFollowUpResponseDetails> =
    z.union([
        CloverPaymentRequestFollowUpVoidResponseDetailsSchema,
        CloverPaymentRequestFollowUpRefundResponseDetailsSchema,
    ]);

export const CloverPaymentRequestFollowUpTransactionResultSchema: z.ZodType<CloverPaymentRequestFollowUpTransactionResult> =
    z.object({
        paymentTransactionUuid: z.string().min(1),
        merchantTransactionId: z.string().min(1).optional(),
        success: z.boolean(),
        gatewayTransactionId: z.string().min(1).optional(),
        amount: z.string().min(1).optional(),
        errorMessage: z.string().min(1).optional(),
    });

export const CloverPaymentRequestFollowUpResultSchema: z.ZodType<CloverPaymentRequestFollowUpResult> =
    z.object({
        success: z.boolean(),
        transactionCount: z.number().int().nonnegative(),
        successfulTransactionCount: z.number().int().nonnegative(),
        failedTransactionCount: z.number().int().nonnegative(),
        transactionResults: z.array(CloverPaymentRequestFollowUpTransactionResultSchema),
    });
